import React from 'react';
import { useNavigate } from 'react-router-dom';

// The "How it works" pill that sits in a page header, next to the h1.
//
// Extracted 2026-08-14 when Suppliers, Briefs and Compliance each got an
// explainer. It first went in as a NAV CHILD under each main-menu item, which
// was a mistake twice over: the explainers were invisible from the page they
// explain, and — worse — SidebarNav's row handler toggles the disclosure
// INSTEAD of navigating when an item has children, so giving Suppliers, Briefs
// and Compliance a child quietly stopped their nav rows opening their pages.
//
// The header pill is where people already look, because Documents has had one
// since August. One component so the four can't drift.
export default function HowItWorksButton({ to, label = 'How it works' }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(to)}
      className="flex-shrink-0 inline-flex items-center gap-2 font-['Metropolis'] text-xs font-semibold tracking-[0.05em] text-fusion-forest border border-[#92D400] rounded-full px-4 py-2 hover:bg-active-green/10 transition-colors whitespace-nowrap focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-fusion-forest">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg>
      {label}
    </button>
  );
}
